export default __webpack_public_path__ + "static/1.1-88b097f57a9ed420a139dc6af1180b9d.webp";